import { api } from './client';
import type { Team, User } from './types';

export interface UserTeamMembership {
  id: string;
  role: string;
  createdAt: string;
  team: Team & { isArchived?: boolean };
}

interface UsersResponse {
  data: User[];
  total: number;
  page: number;
  limit: number;
}

export interface CreateUserInput {
  email: string;
  name: string;
  password: string;
  avatarUrl?: string;
}

export interface UpdateUserInput {
  email?: string;
  name?: string;
  password?: string;
  avatarUrl?: string;
  isActive?: boolean;
  timeZone?: string | null;
}

export const usersApi = {
  list: (params?: { page?: number; limit?: number }) => {
    const queryParams = new URLSearchParams();
    if (params?.page !== undefined) queryParams.append('page', String(params.page));
    if (params?.limit !== undefined) queryParams.append('limit', String(params.limit));
    const queryString = queryParams.toString();
    return api.get<UsersResponse>(`/users${queryString ? `?${queryString}` : ''}`);
  },

  get: (id: string) => api.get<{ data: User }>(`/users/${id}`),

  getTeams: (id: string) => api.get<{ data: UserTeamMembership[] }>(`/users/${id}/teams`),

  me: () => api.get<{ data: User }>('/users/me'),

  create: (data: CreateUserInput) => api.post<{ data: User }>('/users', data),

  update: (id: string, data: UpdateUserInput) =>
    api.put<{ data: User }>(`/users/${id}`, data),

  delete: (id: string) => api.delete<{ success: boolean }>(`/users/${id}`),
};
